
import { SiriusBaseComponent } from 'sirius-framework';
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu-liveprocess',
    templateUrl: './inner-menu-liveprocess.component.html',
    styleUrls: ['./inner-menu-liveprocess.component.css']
})
export class InnerMenuLiveProcessComponent extends SiriusBaseComponent<any> {
    constructor() {
        super();
    }
    OnInit() {

    }
}
